import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../hooks/useTheme';

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-neutral-700 transition-colors"
      aria-label="Toggle theme"
    >
      {theme === 'dark' ? (
        <Sun className="w-5 h-5 sm:w-6 sm:h-6 text-yellow-500" />
      ) : (
        <Moon className="w-5 h-5 sm:w-6 sm:h-6 text-blue-500" />
      )}
    </button>
  );
};

export default ThemeToggle;